<template>
  <div class="options">
    <h5 class="options__title">
      {{ $t('comparator.offers.offer.options') }}
    </h5>
    <ul class="options__ul">
      <li class="options__ul__li" v-for="option in options" :key="option.id">
        <div class="options__ul__li__option">
          <div class="options__ul__li__option__text">
            <span>{{ option.name }}</span>
            <div
              v-if="option.description"
              class="options__ul__li__option__text__gm-price"
              v-html="option.description">
            </div>
          </div>
          <div class="options__ul__li__option__input">
            <el-checkbox
              :checked="option.is_chosen"
              :disabled="isCheckboxDisabled"
              @change="checkboxClick(option.id)">
              {{ $n(getPrice(option) || 0, 'currency') }} {{ $t('base.priceType', priceTypeKey) }}
            </el-checkbox>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useDemandStore } from '@/stores';

export default {
  name: 'OfferOptions',
  props: {
    options: {
      default: () => [],
      type: Array,
    },
    serviceId: {
      required: true,
      type: String,
    },
    isCheckboxDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useDemandStore, ['demand']),
    exclTax() {
      return this.demand.show_price_ht;
    },
    priceTypeKey() {
      return this.demand.priceTypeKey;
    },
  },
  methods: {
    getPrice(option) {
      return this.exclTax ? option.price_ht : option.price_unit;
    },
    checkboxClick(optionId) {
      const findIndex = this.options.findIndex((option) => option.id === optionId);
      if (findIndex !== -1) {
        this.options[findIndex].is_chosen = !this.options[findIndex].is_chosen;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.options {
  &__ul {
    padding-left: 18px;
    font-size: 16px;
    &__li {
      &:not(:last-child) {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid var(--nxt-color-grey);
      }
      &__option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__text {
          margin: auto 20px auto 0;
          &__gm-price {
            font-size: 13px;
          }
        }
        &__input {
          width: 120px;
          min-width: 120px;
          font-weight: 700;
          border-radius: 4px;
          padding: 6px;
          background-color: var(--nxt-color-light-grey);
          :deep(.el-checkbox) {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;

            .el-checkbox__label {
              padding-left: 5px;
              padding-right: 10px;
              font-weight: 700;
              color: var(--nxt-color-font);
            }
          }
        }
      }
    }
  }
}
</style>
